import { OddsFormat } from '@bpos';
import { MessageEnvelope } from '@cds/push';
import { isBetBuilderOfferUpdateEnvelope } from '@frontend/sports/content-distribution/feature';
import { OddsOperations } from '@frontend/sports/odds/feature';

import { buildIPriceFromBasePrice, isSuspended, mapLegInfoToClientLegInfo } from '../../../core/group-pick-helpers';
import { BaseBetslipGroupPick, BetslipGroupPick } from '../../../core/picks/betslip-group-pick';
import { BetslipPick } from '../../../core/picks/betslip-pick';

export class BaseBetslipGroupPickUpdater {
    static update(pick: BaseBetslipGroupPick, message: MessageEnvelope, oddsFormat: OddsFormat): BetslipPick {
        if (isBetBuilderOfferUpdateEnvelope(message) && message.payload.sgpId === pick.sgpId) {
            const offerUpdate = message.payload;
            const newPrice = buildIPriceFromBasePrice(offerUpdate.odds);
            const updatedPick = new BetslipGroupPick({
                sgpId: pick.sgpId,
                price: newPrice,
                picks: pick.getLegs(),
                isSuspended: isSuspended(offerUpdate.suspensionState),
                groupInfo: pick.groupInfo,
                legsInfo: mapLegInfoToClientLegInfo(offerUpdate.legs),
                acceptedPrice: pick.acceptedPrice.price,
            });

            if (!OddsOperations.equal(newPrice.nativeOdds, pick.currentPrice!.nativeOdds, oddsFormat)) {
                updatedPick.priceHistory.push({ ...pick.currentPrice! });
            }

            return updatedPick;
        }

        return pick;
    }
}
